import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SEO = ({ title, description, schemaData, ogData, twitterData, canonicalUrl }) => {
  return (
    <HelmetProvider>
      <Helmet>
        {/* Основные мета-теги */}
        {title && <title>{title}</title>}
        {description && <meta name="description" content={description} />}

        {/* Canonical URL */}
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

        {/* Open Graph теги */}
        {ogData?.title && <meta property="og:title" content={ogData.title} />}
        {ogData?.description && <meta property="og:description" content={ogData.description} />}
        {ogData?.url && <meta property="og:url" content={ogData.url} />}
        {ogData?.type && <meta property="og:type" content={ogData.type} />}
        {ogData?.image && <meta property="og:image" content={ogData.image} />}
        {ogData?.locale && <meta property="og:locale" content={ogData.locale} />}

        {/* Twitter Card теги */}
        {twitterData?.card && <meta name="twitter:card" content={twitterData.card} />}
        {twitterData?.title && <meta name="twitter:title" content={twitterData.title} />}
        {twitterData?.description && <meta name="twitter:description" content={twitterData.description} />}
        {twitterData?.image && <meta name="twitter:image" content={twitterData.image} />}
        {twitterData?.site && <meta name="twitter:site" content={twitterData.site} />}
        {twitterData?.creator && <meta name="twitter:creator" content={twitterData.creator} />}

        {/* JSON-LD (микроразметка) */}
        {schemaData && (
          <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        )}
      </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
